import { ApolloError } from '@apollo/client';
import { Stack, Typography } from '@mui/material';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  LinearProgress,
  Button,
} from '@occc-app/design-system';
import { LoadedContent } from '@occc-app/design-system/components';
import { RetailerNetworkScanDataLatestSubmissionsFragment } from '@occc/graphql';

import { TobaccoSubmissionsTableRow } from './tobacco-submissions-table-row.component';

export type TobaccoSubmissionsTableProps = {
  data?: RetailerNetworkScanDataLatestSubmissionsFragment[];
  loading: boolean;
  error?: ApolloError;
  onViewAllStoresClick: (submission: RetailerNetworkScanDataLatestSubmissionsFragment) => void;
  onViewAllSubmissionsClick: () => void;
};

export const TobaccoSubmissionsTable = ({
  data,
  loading,
  error,
  onViewAllStoresClick,
  onViewAllSubmissionsClick,
}: TobaccoSubmissionsTableProps) => {
  const numberOfSubmissions = data?.length ?? 0;
  const renderData = (items: RetailerNetworkScanDataLatestSubmissionsFragment[]) => (
    <TableContainer>
      <TableHeader
        title={
          <Stack direction='column'>
            <Typography variant='subtitle1' fontWeight={600} gutterBottom>
              Scan Data Submissions
            </Typography>
            <Typography variant='body2' color='gray' gutterBottom>
              Last {numberOfSubmissions} Submitted Reports
            </Typography>
          </Stack>
        }
        actions={
          <Stack direction='row' alignItems='center' gap={1}>
            <Button variant='contained' color='primary' onClick={onViewAllSubmissionsClick}>
              View all Submissions
            </Button>
          </Stack>
        }
      />
      {loading && <LinearProgress />}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Weekly Submission</TableCell>
            <TableCell>Submission Status</TableCell>
            <TableCell>Stores Submitted</TableCell>
            <TableCell>Multi Unit Trans.</TableCell>
            <TableCell>Loyalty Trans.</TableCell>
            <TableCell align='right'>Est. Reimbursement</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <TobaccoSubmissionsTableRow
              key={index}
              item={item}
              onViewAllStoresClick={onViewAllStoresClick}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return <LoadedContent error={error} loading={loading} items={data} renderData={renderData} />;
};
